class UserListDetails {
  constructor() {
    this.UserOid = [];
    this.UserName = [];
    this.FirstName = [];
    this.LastName = [];
    this.UserEmail = [];
    this.CreatedDate = [];
    this.UserType = [];
    //this.Roles= [][];
    this.Status = [];
    this.UserListDetailResp = null;
    this.UserRolesResp = null;
  }

  getUserOid(index) {
    return this.UserOid[index];
  }

  setUserOid(index, Oid) {
    this.UserOid[index] = Oid;
  }

  getUserName(index) {
    return this.UserName[index];
  }

  setUserName(index, Username) {
    this.UserName[index] = Username;
  }

  getFirstName(index) {
    return this.FirstName[index];
  }

  setFirstName(index, FirstName) {
    this.FirstName[index] = FirstName;
  }

  getLastName(index) {
    return this.LastName[index];
  }

  setLastName(index, LastName) {
    this.LastName[index] = LastName;
  }

  getUserEmail(index) {
    return this.UserEmail[index];
  }

  setUserEmail(index, UserEmail) {
    this.UserEmail[index] = UserEmail;
  }

  getCreatedDate(index) {
    return this.CreatedDate[index];
  }

  setCreatedDate(index, CreatedDate) {
    this.CreatedDate[index] = CreatedDate;
  }

  getUserType(index) {
    return this.UserType[index];
  }

  setUserType(index, UserType) {
    this.UserType[index] = UserType;
  }

  getStatus(index) {
    return this.Status[index];
  }

  setStatus(index, Status) {
    this.Status[index] = Status;
  }

  getUserListDetailResp() {
    return this.UserListDetailResp;
  }

  setUserListDetailResp(UserListDetailResp) {
    this.UserListDetailResp = UserListDetailResp;
  }

  getUserRolesResp() {
    return this.UserRolesResp;
  }

  setUserRolesResp(UserRolesResp) {
    this.UserRolesResp = UserRolesResp;
  }

  resetUserListDetails() {
    this.UserOid = [];
    this.UserName = [];
    this.FirstName = [];
    this.LastName = [];
    this.UserEmail = [];
    this.CreatedDate = [];
    this.UserType = [];
    //this.Roles= [][];
    this.Status = [];
    this.UserListDetailResp = null;
    this.UserRolesResp = null;
  }
}
export default new UserListDetails();
